import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import { parseErrorArrayAndThrowMsg } from './utils';

const DataApiUrl = dataApiUrl();

const PlatformFees = () => {
  const createFee = data =>
    AuthAxios.post(`${DataApiUrl}/admin/platformFees`, data)
      .then(res => res.data.data)
      .catch(parseErrorArrayAndThrowMsg('Creating fee'));

  const patchFee = (feeId, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/platformFees/${feeId}`, data)
      .then(res => res.data.data)
      .catch(parseErrorArrayAndThrowMsg('Patching fee'));

  return {
    createFee,
    patchFee,
  };
};

export default PlatformFees;
